import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { collection, doc, docData, FieldPath, Firestore, getDoc, getDocs, limit, query, where } from '@angular/fire/firestore';
import firebase from 'firebase/compat/app';
import { BehaviorSubject, take } from 'rxjs';

const defaultImage: string = "https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/posters2%2FLionsgate-Repertory-default-poster.jpg?alt=media&token=19972e79-65ee-417a-a824-a4cd7d7733ff"

const defaultTopBg: string = "https://firebasestorage.googleapis.com/v0/b/lionsgate-repository.firebasestorage.app/o/pageBg%2FLionsgate-Repertory-default-horizontal.jpg?alt=media&token=9663bf8c-41a1-4073-a26e-86ce0d92bf8d"

export class TopPromo {
    img: string = ''
    imgMob: string = ''
    url: string = ''
    starring: string = ''
    title: string = ''
    video: string = ''
    videoMob: string = ''
    Dx: number = 0
    movie: Movie

    constructor(data: any) {
        this.Dx = data.Dx
        this.img = data.img
        this.imgMob = data.imgMob
        this.url = data.url
        this.starring = data.starring
        this.title = data.title
        this.video = data.video
        this.videoMob = data.videoMob
        this.movie = data.movie
    }
}

export class SquarePromo {
    image: string
    title: string
    search: string

    constructor(data: any) {
        this.image = data.image ? data.image : ''
        this.title = data.title ? data.title : ''
        this.search = data.search ? data.search : ''
    }
}

export class SearchPage {
    genreList: SquarePromo[]

    constructor(data: any) {
        this.genreList = (data && data.genreList) ? data.genreList : []

        this.initGenre()
    }

    initGenre() {
        const genreList = [

            {
                image: 'assets/genre/genre-1.png',
                title: 'Action',
                search: 'Action'
            },
            {
                image: 'assets/genre/genre-2.png',
                title: 'Horror',
                search: 'Horror'
            },
            {
                image: 'assets/genre/genre-3.png',
                title: 'Comedy',
                search: 'Comedy'
            },
            {
                image: 'assets/genre/genre-4.png',
                title: 'Romance',
                search: 'Romance'
            },
            {
                image: 'assets/genre/genre-5.png',
                title: 'Thriller',
                search: 'Thriller'
            },
            {
                image: 'assets/genre/genre-6.png',
                title: 'Drama',
                search: 'Drama'
            },
            // {
            //     image: 'assets/genre/genre-animation.png',
            //     title: 'Animation',
            //     search: 'Animation'
            // },
            {
                image: 'assets/genre/genre-faith.png',
                title: 'Faith',
                search: 'Faith'
            },
            {
                image: 'assets/genre/genre-family.png',
                title: 'Family',
                search: 'Family'
            },
            {
                image: 'assets/genre/genre-mystery.png',
                title: 'Mystery',
                search: 'Mystery'
            },
            {
                image: 'assets/genre/genre-sci-fi.png',
                title: 'Sci-Fi',
                search: 'Sci-Fi'
            },
            // {
            //     image: 'assets/genre/genre-suspense.png',
            //     title: 'Suspense',
            //     search: 'Suspense'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Adventure',
            //     search: 'Adventure'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Children',
            //     search: 'Children'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Christmas Movie',
            //     search: 'Christmas Movie'
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Crime',
                search: 'Crime'
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Dark Comedy',
            //     search: 'Dark Comedy'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Detective Thriller',
            //     search: 'Detective Thriller'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Documentary',
            //     search: 'Documentary'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Fantasy',
            //     search: 'Fantasy'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Foreign',
            //     search: 'Foreign'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Latino',
            //     search: 'Latino'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Murder',
            //     search: 'Murder'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Action/Adventure',
            //     search: 'Action/Adventure'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Music/Musical',
            //     search: 'Music/Musical'
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Mystery/Suspense',
                search: 'Mystery/Suspense'
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Psychological Thriller',
            //     search: 'Psychological Thriller'
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Romantic Comedy',
                search: 'Romantic Comedy'
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Sexual Comedy',
            //     search: 'Sexual Comedy'
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Special Interest',
            //     search: 'Special Interest'
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Sports',
                search: 'Sports'
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Unscripted',
                search: 'Unscripted'
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'War',
                search: 'War'
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Western',
                search: 'Western'
            },

        ]

        this.genreList = genreList
    }
}

export class HomePage {
    top: TopPromo[] = []
    bottom: TopPromo[] = []
    criticallyAcclaimed: number[] = []
    criticallyAcclaimedList: Movie[] = []
    featured: number[] = []
    featuredList: Movie[] = []
    newlyCreated: number[] = []
    newlyCreatedList: Movie[] = []
    classics: number[] = []
    classicsList: Movie[] = []
    tarantino: number[] = []
    tarantinoList: Movie[] = []
    franchiseFavs: number[] = []
    franchiseFavsList: Movie[] = []
    action: number[] = []
    actionList: Movie[] = []
    spooky: number[] = []
    spookyList: Movie[] = []
    horror: number[] = []
    horrorList: Movie[] = []
    nytTop: number[] = []
    nytTopList: Movie[] = []
    romance: number[] = []
    romanceList: Movie[] = []

    franciseList: SquarePromo[] = []

    constructor(data: any) {
        if (data) {
            this.top = data.top.map((topPromo: any) => new TopPromo(topPromo))
            this.criticallyAcclaimed = data.criticallyAcclaimed
            this.featured = data.featured
            this.newlyCreated = data.newlyCreated
            this.classics = data.classics
            this.tarantino = data.tarantino
            this.franchiseFavs = data.franchiseFavs
            this.action = data.action
            this.spooky = data.spooky
            this.horror = data.horror
            this.nytTop = data.nytTop
            this.romance = data.romance

            this.franciseList = data.franciseList ? data.franciseList : ''

            this.bottom = data.bottom.map((topPromo: any) => new TopPromo(topPromo))
        }

        this.initFranciseList()
    }

    initFranciseList() {
        this.franciseList = [
            {
                image: 'assets/franchise/fr-1.png',
                title: '',
                search: 'Divergent'
            },
            {
                image: 'assets/franchise/fr-2.png',
                title: '',
                search: 'Twilight'
            },
            {
                image: 'assets/franchise/fr-3.png',
                title: '',
                search: 'John Wick'
            },
            {
                image: 'assets/franchise/fr-4.png',
                title: '',
                search: 'Hunger Games'
            },
            {
                image: 'assets/franchise/fr-5.png',
                title: '',
                search: 'Saw'
            },
            {
                image: 'assets/franchise/now-you-see-me-franchise.png',
                title: '',
                search: 'Now You See Me'
            },
            {
                image: 'assets/franchise/rambo-franchise.png',
                title: '',
                search: 'Rambo'
            },
        ]
    }
}

export class Movie {
    Dx: number;
    Title: string;
    Release: number;
    EndDate: Date;
    Rights_Restriction: boolean;
    Rights_Restriction_Text: string;
    Rating: string;
    Genre: string;
    GenreList: string[];
    Cast: string;
    CastList: string[];
    Synopsis: string;
    Director: string;
    DirectorList: string[];
    Writer: string;
    WriterList: string[];
    Producer: string;
    ProducerList: string[];
    Runtime: number;
    CountryOfOrigin: string;
    OrigLang: string;
    DCP: boolean;
    DCP_Duration: string;
    DCP_Aspect_Ratio: string;
    DCP_Resolution: string;
    ThirtyFiveMmPrint: boolean;
    Poster: string;
    PosterFilename: string;
    Promo: string;
    isDefault: boolean = false;
    pageBg: string
    pageBgList: string[] = []
    videoBg: string = ''
    FormatList: string[] = []
    Franchise: string = ''

    constructor(source?: any) {
        this.Dx = source?.Dx ?? 0;
        if (this.Dx == 9382431) {
            console.log('debug expendables 2')
        }

        this.Title = source?.Title ?? '';
        this.Release = source?.Release ?? 0;
        this.EndDate = source?.EndDate ? new Date(source.EndDate) : new Date();
        this.Rights_Restriction = source?.Rights_Restriction ?? false;
        this.Rights_Restriction_Text = source?.Rights_Restriction_Text ?? '';
        this.Rating = source?.Rating ?? '';
        this.Genre = source?.Genre ?? '';
        this.GenreList = source?.GenreList ? [...source?.GenreList] : [];
        this.Cast = source?.Cast ?? '';
        this.CastList = source?.CastList ? [...source.CastList] : [];
        this.Synopsis = source?.Synopsis ?? '';
        this.Director = source?.Director ?? '';
        this.DirectorList = source?.DirectorList ? [...source.DirectorList] : [];
        this.Writer = source?.Writer ?? '';
        this.WriterList = source?.WriterList ? [...source.WriterList] : [];
        this.Producer = source?.Producer ?? '';
        this.ProducerList = source?.ProducerList ? [...source.ProducerList] : [];
        this.Runtime = source?.Runtime ?? 0;
        this.CountryOfOrigin = source?.CountryOfOrigin ?? '';
        this.OrigLang = source?.OrigLang ?? '';
        this.DCP = source?.DCP ?? false;
        this.DCP_Duration = (source && source['DCP_Duration']) ? source['DCP_Duration'] : '';
        this.DCP_Aspect_Ratio = (source && source['DCP_Aspect_Ratio']) ? source['DCP_Aspect_Ratio'] : '';
        this.DCP_Resolution = (source && source['DCP_Resolution']) ? source['DCP_Resolution'] : '';
        this.ThirtyFiveMmPrint = false
        if (source && source['35mm_Print']) {
            this.ThirtyFiveMmPrint = source['35mm_Print'] ? source['35mm_Print'] == true : false;
        }
        if (source && source.ThirtyFiveMmPrint && source.ThirtyFiveMmPrint == true) {
            this.ThirtyFiveMmPrint = source.ThirtyFiveMmPrint
        }

        this.Poster = source?.Poster && source?.Poster != '' ? source?.Poster : defaultImage;
        if (this.Poster == defaultImage) {
            this.isDefault = true
        }
        this.PosterFilename = source?.PosterFilename ?? '';

        this.Promo = source?.Promo && source?.Promo != '' ? source?.Promo : '';
        this.pageBg = source?.pageBg && source?.pageBg != '' ? source?.pageBg : defaultTopBg;
        this.pageBgList = source?.pageBgList ? source.pageBgList : []
        if (this.pageBgList.length == 0) {
            this.pageBgList.push(this.pageBg)
        }
        this.FormatList = source?.FormatList ? source.FormatList : []
        this.Franchise = source?.Franchise && source?.Franchise != '' ? source?.Franchise : '';

        for (let i = 0; i < this.FormatList.length; i++) {
            if (this.FormatList[i] == "DCP -Digital Content Package") {
                this.FormatList[i] = "DCP"

                if (source && source.DCP_Resolution == '4K') {
                    this.FormatList[i] = "DCP -4K"
                }
                if (source && source.DCP_Resolution == '2K') {
                    this.FormatList[i] = "DCP -2K"
                }
            }
        }

        if (this.FormatList.length == 0) {
            this.FormatList.push('Rights Only -Self Supplied');
        }

        this.videoBg = source?.videoBg ? source?.videoBg : ''
    }

    clone(source?: any) {
        this.Dx = source?.Dx ?? 0;
        this.Title = source?.Title ?? '';
        this.Release = source?.Release ?? 0;
        this.EndDate = source?.EndDate ? new Date(source.EndDate) : new Date();
        this.Rights_Restriction = source?.Rights_Restriction ?? false;
        this.Rights_Restriction_Text = source?.Rights_Restriction_Text ?? '';
        this.Rating = source?.Rating ?? '';
        this.Genre = source?.Genre ?? '';
        this.Cast = source?.Cast ?? '';
        this.CastList = source?.CastList ? [...source.CastList] : [];
        this.Synopsis = source?.Synopsis ?? '';
        this.Director = source?.Director ?? '';
        this.DirectorList = source?.DirectorList ? [...source.DirectorList] : [];
        this.Writer = source?.Writer ?? '';
        this.WriterList = source?.WriterList ? [...source.WriterList] : [];
        this.Producer = source?.Producer ?? '';
        this.ProducerList = source?.ProducerList ? [...source.ProducerList] : [];
        this.Runtime = source?.Runtime ?? 0;
        this.CountryOfOrigin = source?.CountryOfOrigin ?? '';
        this.OrigLang = source?.OrigLang ?? '';
        this.DCP = source?.DCP ?? false;
        this.DCP_Duration = (source && source["DCP_Duration"]) ?? '';
        this.DCP_Aspect_Ratio = source?.DCP_Aspect_Ratio ?? '';
        this.DCP_Resolution = source?.DCP_Resolution ?? '';
        this.ThirtyFiveMmPrint = source?.ThirtyFiveMmPrint ?? false;
        this.Poster = source?.Poster ?? '';
        this.PosterFilename = source?.PosterFilename ?? '';
        this.Promo = source?.Promo ?? '';
        if (this.Poster == defaultImage) {
            this.isDefault = true
        }
        this.pageBg = source?.pageBg && source?.pageBg != '' ? source?.pageBg : '';
        this.videoBg = source?.videoBg ?? '';
        this.Franchise = source?.Franchise && source?.Franchise != '' ? source?.Franchise : '';
    }
}

@Injectable({
    providedIn: 'root'
})
export class PageService {
    private firestore = inject(Firestore);
    private destroyRef = inject(DestroyRef);

    public homePage: HomePage = new HomePage(null)
    public homePage$: BehaviorSubject<HomePage | null>
    public defaultImage: string = defaultImage
    public searchPage: SearchPage = new SearchPage(null)

    constructor() {
        // this.initHomePage()
        this.homePage$ = new BehaviorSubject<HomePage | null>(null)
        // this.initHomePage()
    }

    initHomePage() {
        const homePageDocRef = doc(this.firestore, `pages/home`);

        // Subscribe to document changes
        docData(homePageDocRef, { idField: 'id' }).pipe(
            take(1),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe({
            next: (data) => {
                this.homePage = new HomePage(data)
                this.getMoviesByIds(this.homePage.criticallyAcclaimed).then(movies => {
                    this.homePage.criticallyAcclaimedList = movies;
                });
                this.getMoviesByIds(this.homePage.featured).then(movies => {
                    this.homePage.featuredList = movies;
                });
                this.getMoviesByIds(this.homePage.newlyCreated).then(movies => {
                    this.homePage.newlyCreatedList = movies;
                });
                this.getMoviesByIds(this.homePage.classics).then(movies => {
                    this.homePage.classicsList = movies;
                });
                this.getMoviesByIds(this.homePage.tarantino).then(movies => {
                    this.homePage.tarantinoList = movies;
                });
                this.getMoviesByIds(this.homePage.franchiseFavs).then(movies => {
                    this.homePage.franchiseFavsList = movies;
                });
                this.getMoviesByIds(this.homePage.action).then(movies => {
                    this.homePage.actionList = movies;
                });
                this.getMoviesByIds(this.homePage.spooky).then(movies => {
                    this.homePage.spookyList = movies;
                });
                this.getMoviesByIds(this.homePage.horror).then(movies => {
                    this.homePage.horrorList = movies;
                });
                this.getMoviesByIds(this.homePage.nytTop).then(movies => {
                    this.homePage.nytTopList = movies;
                });
                this.getMoviesByIds(this.homePage.romance).then(movies => {
                    this.homePage.romanceList = movies;
                });

                let dxIds = this.homePage.top.map(item => item.Dx)
                this.getMoviesByIds(dxIds).then(movies => {
                    movies.forEach(movie => {
                        this.homePage.top.forEach(top => {
                            if (top.Dx == movie.Dx) {
                                top.movie = movie
                            }
                        })
                    })
                });
                let dxIds2 = this.homePage.bottom.map(item => item.Dx)
                this.getMoviesByIds(dxIds2).then(movies => {
                    movies.forEach(movie => {
                        this.homePage.bottom.forEach(top => {
                            if (top.Dx == movie.Dx) {
                                top.movie = movie
                            }
                        })
                    })
                });



            },
            error: (err) => {
                console.error('Error fetching admin user:', err);
            }
        });
    }

    async getMoviesByIds(DxList: number[]): Promise<Movie[]> {


        if (!DxList || DxList.length === 0) {
            return [];
        }
        let ids = DxList.map(dx => '' + dx);

        if (ids.indexOf('9382431') != -1) {
            console.log('debug expendables 2')
        }
        if (ids.length > 20) {
            ids = ids.slice(0, 20)
        }

        const moviesCollection = collection(this.firestore, 'movies');
        const q = query(moviesCollection, where(firebase.firestore.FieldPath.documentId(), 'in', ids));
        const querySnapshot = await getDocs(q);
        // return querySnapshot.docs.map(doc => new Movie(doc.data()));

        let unsorted = querySnapshot.docs.map(doc => new Movie(doc.data()));
        let sorted: Movie[] = []
        DxList.forEach((id) => {

            unsorted.forEach(movie => {

                if (movie.Dx == id) {
                    sorted.push(new Movie(movie))
                }
            })
        })
        return sorted
    }

    async getMoviesByGenre(genre: string[]): Promise<Movie[]> {


        const moviesCollection = collection(this.firestore, 'movies');
        const q = query(
            moviesCollection,
            where('GenreList', 'array-contains-any', genre),
            limit(50)
        );
        const querySnapshot = await getDocs(q);
        // return querySnapshot.docs.map(doc => new Movie(doc.data()));

        let result = querySnapshot.docs.map(doc => new Movie(doc.data()));
        // let sorted: Movie[] = []
        // DxList.forEach((id) => {

        //     unsorted.forEach(movie => {
        //         if (movie.Dx == id) {
        //             sorted.push(new Movie(movie))
        //         }
        //     })
        // })
        return result
    }
}
